module.exports = __webpack_public_path__ + "static/media/00-eCSPlus-Ru-gy_4x.1f311738.png";